import React from "react";

import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

export default class SearchLink extends React.Component<any, any> {
  render() {
    return (
      <div className="name">
        <div className="global-nav-search">
          <form>
            <i className="fa fa-search" />
            <input
              type="text"
              placeholder={i18n.translate("shared.search.search_bonusly")}
            />
            <div id="clear-search" />
          </form>
        </div>
      </div>
    );
  }
}
